import script from "./WordStats.vue?vue&type=script&lang=ts&setup=true"
export * from "./WordStats.vue?vue&type=script&lang=ts&setup=true"

import "./WordStats.vue?vue&type=style&index=0&id=731bf41b&lang=sass"

const __exports__ = script;

export default __exports__